import {
    FETCH_BENCHMARK_TAXONOMY_START,
    FETCH_BENCHMARK_TAXONOMY_SUCCESS,
    FETCH_BENCHMARK_TAXONOMY_FAIL

} from "../../../constants";
import {
    FETCH_BENCHMARK_TAXONOMY_URL,
} from "../../../../../config/constants";
import { ApiBase } from "../../../../utils/apiBase";
import { withType } from "../../../../utils/actionOperations";
import { getProjectIdAndOrgId } from '../../../../utils/apiUtils';
import { SETTINGS_PAGE_SECTION } from "../../../../../config/tabConstants";

export const getBenchmarkTaxonomy = (payload, cb) => {
    const apiBaseInstance = new ApiBase().instance;
    return (dispatch) => {
        dispatch(
            withType(FETCH_BENCHMARK_TAXONOMY_START, { ...payload })
        );
        return apiBaseInstance
            .post(FETCH_BENCHMARK_TAXONOMY_URL, {
                ...payload, ...getProjectIdAndOrgId(payload), currentTab: SETTINGS_PAGE_SECTION.SETTINGS_SUB_TABS.ADMINISTRATOR
            })
            .then((res) => {
                dispatch(
                    withType(FETCH_BENCHMARK_TAXONOMY_SUCCESS, {
                        data: res.data,
                        payload: payload
                    })
                );
                cb && cb(true, res.data)
            })
            .catch((err) => {
                dispatch(withType(FETCH_BENCHMARK_TAXONOMY_FAIL, { ...err, ...payload }));
                cb && cb(false)
            });
    };
};
